// Справочник типов долга: код и название по-русски.
//
// Живёт в общем слое, потому что понадобился ДВУМ разделам: форме заведения долга в карточке
// человека и отбору реестра долгов в «Расчёте». Разделы друг к другу за хуками не ходят, а два
// собственных хука на один справочник — это две политики кэша и два места, куда придётся
// вспомнить заглянуть, когда у справочника появится, например, отбор по действующим.
//
// Названия приходят с сервера: словарь живёт в `contracts/enums/statuses.yaml`, и копия его на
// клиенте расходится с ним молча — заведут новый тип, и человек увидит «uniform» вместо «Форма».

import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';

import type { DebtTypeNameOut } from '@/shared/api/endpoints/losses';
import { fetchDebtTypes } from '@/shared/api/endpoints/losses';
import type { ListResponse } from '@/shared/api/types';
import type { ApiError } from '@/shared/errors/api-error';

export function useDebtTypes(): UseQueryResult<ListResponse<DebtTypeNameOut>, ApiError> {
  return useQuery<ListResponse<DebtTypeNameOut>, ApiError>({
    queryKey: ['dictionaries', 'debt-types'],
    queryFn: () => fetchDebtTypes(),
    // Справочник из контракта: он меняется вместе с выкладкой, а не в течение смены.
    staleTime: 10 * 60 * 1000,
  });
}
